// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"0fa9e614","556":"16f4e67b","603":"2f490a07","695":"68c31d4a","780":"96bb8deb","787":"d5b3d5bb","942":"ce409555"}[chunkId] + ".chunk.js";
};